import { usePage } from '@inertiajs/react'
import { t } from '@/shared/lib/i18n'
import type { SharedProps } from '@/shared/types/SharedProps'
import SignoffStatsSummary from './components/SignoffStatsSummary'
import PendingSignoffsTable from './components/PendingSignoffsTable'
import DepartmentChainStatusTable, {
  type DepartmentChainRow,
} from './components/DepartmentChainStatusTable'

interface StatsProps {
  pendingSignoffsTotal: number
  departmentsWithoutChain: number
}

interface PendingSignoffRow {
  departmentId: number
  departmentName: string
  siteName: string | null
  pendingCount: number
  oldestPendingDate: string | null
}

interface SignoffMonitoringPageProps {
  stats: StatsProps
  pendingSignoffsByDepartment: PendingSignoffRow[]
  departmentChainStatus: DepartmentChainRow[]
}

type PageProps = SharedProps & SignoffMonitoringPageProps

const SignoffMonitoringPage = () => {
  const { stats, pendingSignoffsByDepartment, departmentChainStatus } = usePage<PageProps>().props

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold">{t('admin.signoffMonitoring.pageTitle')}</h1>

      <SignoffStatsSummary
        pendingSignoffsTotal={stats.pendingSignoffsTotal}
        departmentsWithoutChain={stats.departmentsWithoutChain}
      />

      <PendingSignoffsTable pendingSignoffsByDepartment={pendingSignoffsByDepartment} />

      <DepartmentChainStatusTable departmentChainStatus={departmentChainStatus} />
    </div>
  )
}

export default SignoffMonitoringPage
